<template>
  <div class="position-relative" :class="{ 'top-fix-padd': topFixedMessage }">
    <top-fixed-message v-if="topFixedMessage" @close="closeBanner" />
    <div
      class="content action-content"
      :class="{ 'action-content-full': fullWidth }"
    >
      <mc-fix-alert></mc-fix-alert>
      <mc-fix-alert-maintenance />

      <FadeTransition :duration="200" mode="out-in">
        <section class="section-create" :class="{ 'with-footer': showFooter }">
          <b-container fluid :class="containerClass">
            <b-row class="pt-4" v-show="noHeader">
              <b-col>
                <b-row align-v="center">
                  <b-col cols="auto" class="d-none" v-if="icon">
                    <div class="breadcrumbs-ico">
                      <img
                        :src="
                          icon
                            ? require('@/assets/img/icons/ico-' + icon + '.svg')
                            : ''
                        "
                        width="18"
                        alt="ico"
                      />
                    </div>
                  </b-col>
                  <b-col cols="auto" v-if="backIcon" class="pr-0">
                    <b-button
                      variant="outline-primary-new"
                      type="button"
                      class="btn-sm round-10 px-2"
                      @click="$emit('close')"
                    >
                      <img
                        src="@/assets/img/icons/back-icon.svg"
                        width="18"
                        class="align-text-bottom"
                        alt="back"
                      />
                    </b-button>
                  </b-col>
                  <b-col>
                    <div
                      v-if="showBack"
                      class="d-flex align-items-baseline pt-1"
                    >
                      <span class="display-flex">
                        <button
                          type="button"
                          class="btn btn-sm back-btn mc-btn-ico"
                          @click="$emit('close')"
                        >
                          <img
                            src="@/assets/img/icons/back-icon.svg"
                            width="18"
                            class="align-text-bottom"
                            alt="back"
                          />
                        </button>
                      </span>
                      <span class="font-14 fw-500 text-darken ml-2 mt-1"
                        >Back</span
                      >
                      <span class="text-7d font-13 font-weight-bold mx-1 mt-1">
                        /
                      </span>
                      <span
                        class="text-7d font-14 text-break mt-1"
                        id="actionPageTitle"
                        v-b-tooltip
                        :title="truncate && title.length > 0 ? title : ''"
                      >
                        {{ truncate ? truncateTitle : title }}
                      </span>
                    </div>
                    <h1
                      v-else
                      class="font-24 font-head breadcrumbs-title text-break"
                      id="actionPageTitle"
                      v-b-tooltip
                      :title="truncate && title.length > 0 ? title : ''"
                    >
                      {{ truncate ? truncateTitle : title }}
                    </h1>
                    <p v-if="subTitle" class="font-13 text-700 m-0 lh-normal">
                      {{ subTitle }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
              <slot name="right_action"></slot>
              <b-col align-self="start" cols="auto" class="ml-auto">
                <b-link
                  id="btnCloseAction"
                  variant="link"
                  size="sm"
                  class="close"
                  @click="$emit('close')"
                  >×</b-link
                >
              </b-col>
            </b-row>
            <b-row v-show="noHeader">
              <slot name="right_header">
                <b-col
                  cols="auto"
                  align-self="center"
                  class="text-center mt-5 mt-md-2 mt-lg-0 action-center-col mx-auto"
                  v-if="progress"
                >
                  <mc-progress
                    :value="progress.value"
                    :steps="progress.steps"
                    @change="$emit('changeProgress', $event)"
                  ></mc-progress>
                </b-col>
              </slot>
            </b-row>
            <b-button
              v-if="!noHeader"
              id="btnCloseAction"
              variant="link"
              size="lg"
              class="close-action-pop text-reset"
              @click="$emit('close')"
              ><img src="@/assets/img/icons/close.svg" width="18" alt="X"
            /></b-button>
          </b-container>
          <b-container fluid>
            <slot></slot>
            <slot name="footer_action" v-if="showFooter">
              <div class="create-section-footer border-top">
                <b-container fluid>
                  <b-row>
                    <b-col>
                      <b-button
                        id="btnBackAction"
                        variant="white"
                        class="btnw-100 border"
                        @click="$emit('back')"
                        :disabled="disabled && backbutton"
                        v-if="!hideBack"
                        ><img
                          src="@/assets/img/icons/left-arrow.svg"
                          alt="go"
                          class="d-inline-block mr-2"
                          width="24"
                        />Back</b-button
                      >
                    </b-col>
                    <b-col cols="auto" class="ml-auto">
                      <b-button
                        id="btnConfirmAction"
                        variant="primary"
                        class="btnw-120"
                        @click="$emit('confirm')"
                        :disabled="disabled || disableContinue"
                        ><img
                          src="@/assets/img/theme/btn-loading.svg"
                          alt="load"
                          class="d-inline-block"
                          width="75"
                          v-if="loading" />

                        <span v-if="!loading"
                          >{{ confirmButtonText
                          }}<img
                            src="@/assets/img/icons/right-arrow.svg"
                            alt="go"
                            class="d-inline-block ml-2"
                            width="24" /></span
                      ></b-button>
                    </b-col>
                  </b-row>
                </b-container>
              </div>
            </slot>
          </b-container>
        </section>
      </FadeTransition>
    </div>
    <chat-boat v-if="isMainUser" />
  </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";
import McProgress from "@/components/McProgress";
import McFixAlert from "@/components/McFixAlert";
import McFixAlertMaintenance from "@/components/McFixAlertMaintenance";
import TopFixedMessage from "@/components/TopFixedMessage";
import { mapState } from "vuex";
import { getChatbotUserStatus } from "@/common/functions";
import ChatBoat from "@/components/ChatBoat";
export default {
  name: "ActionLayout",
  components: {
    FadeTransition,
    McProgress,
    McFixAlert,
    McFixAlertMaintenance,
    TopFixedMessage,
    ChatBoat,
  },
  created() {
    var vm = this;
    setTimeout(() => {
      vm.isMainUser = getChatbotUserStatus(vm);
    }, 2000);
  },
  data() {
    return {
      isMainUser: false,
    };
  },
  methods: {
    closeBanner() {
      this.$store.commit("dashboard/setShowLifetimeSuccess", false);
    },
  },
  computed: {
    ...mapState({
      showLifetimeSuccess: (state) => state.dashboard.showLifetimeSuccess,
    }),
    isApproved() {
      return !(
        this.$ls.get("is_approve") && parseInt(this.$ls.get("is_approve")) === 0
      );
    },
    truncateTitle() {
      if (this.title.length > 20) {
        return this.title.substring(0, 20) + "...";
      }
      return this.title;
    },
    topFixedMessage() {
      if (!this.isApproved || this.showLifetimeSuccess) {
        return true;
      } else {
        return false;
      }
    },
  },
  props: {
    noHeader: { default: true },
    title: { default: "" },
    icon: { default: "" },
    progress: { default: "" },
    showFooter: { default: true },
    disabled: { default: false },
    loading: { default: false },
    hideBack: { type: Boolean, default: false },
    truncate: { type: Boolean, default: false },
    backbutton: { default: false },
    fullWidth: { default: false },
    confirmButtonText: { default: "Continue" },
    disableContinue: { default: false },
    containerClass: { default: "" },
    showBack: {
      type: Boolean,
      default: false,
    },
    backIcon: {
      type: Boolean,
      default: false,
    },
    subTitle: {
      type: [String, Boolean],
      default: false,
    },
  },
};
</script>
